<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import Button from '../Vehicles/Button.svelte';
    import ButtonBack from '../../shared/ButtonBack.svelte';
    import MessageInline from '../../shared/Messages/MessageInline.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import ButtonRemove from '../../shared/ButtonRemove.svelte';

    export let isOpen: boolean = false;
    export let text: string = '';
    export let name: string = '';
    export let onClick: () => void = () => {};
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <h3 style="text-align: center;">{text}</h3>
            <h3 style="text-align: center;">{name}</h3>

            <div class="actions">
                <ButtonBack text={$_('No')} showIcon={false} on:click={closeModal} />
                <ButtonRemove
                    text={$_('Remove')}
                    on:click={() => {
                        onClick();
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 390px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--analytics-red);
        box-shadow:
            0 0 0 10px #d93b4d44,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
